/**
 * Helper conversioni Google Ads. Stessa filosofia di metaPixelEvents: se il tag
 * non è attivo (consenso profilazione negato, tag spento da admin) window.gtag
 * non esiste e la chiamata è un no-op silenzioso — i chiamanti non devono
 * conoscere lo stato del consenso.
 *
 * La destinazione (`AW-<id>/<label>`) arriva già composta da
 * GET /settings/public-config: qui non si sa nulla di come è fatta.
 */

export interface PurchaseConversion {
  /** Importo della ricarica in euro. */
  value: number;
  /**
   * Identificatore univoco del pagamento (id sessione Stripe). Senza questo
   * Google conterebbe due volte la stessa ricarica se la pagina di ritorno
   * venisse ricaricata, quindi in sua assenza non si invia niente.
   */
  transactionId: string;
}

export function trackGoogleAdsPurchase(
  sendTo: string | null | undefined,
  { value, transactionId }: PurchaseConversion,
): void {
  if (!sendTo || !transactionId) return;
  const gtag = window.gtag;
  if (typeof gtag !== 'function') return;

  gtag('event', 'conversion', {
    send_to: sendTo,
    value,
    currency: 'EUR',
    transaction_id: transactionId,
  });
}
